import { headerAuth } from "../standardAuthPatterns";
import { productVariant } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";

export const flexeraSoftwareVulnerabilityResearch = productVariant({
  identifier: "flexeraSoftwareVulnerabilityResearch",
  authLabel: "Software Vulnerability Research",
  protocol: "http",
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://api.app.secunia.com/api"),
  auth: headerAuth([
    {
      name: "Authorization",
      value: { from: "template", template: "Token {secrets.apiToken}" },
    },
  ]),
  steps: [
    {
      title: "Set up Flexera Software Vulnerability Research",
      items: [
        {
          kind: "markdown",
          content:
            "In Software Vulnerability Research, open **Settings > API > Tokens** and copy an API access token for an account with access to advisories. See the [token instructions](https://docs.flexera.com/svm-research/api-help-library/api-introduction/tokens).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "url",
          label: "API base URL",
          required: true,
          defaultValue: "https://api.app.secunia.com/api/",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "Use the documented API service at https://api.app.secunia.com/api/. The browsable API Explorer is available at the same API host and requires the credentials used for the account; do not use the Flexera web portal URL as the API base.",
        },
        {
          kind: "input",
          label: "Software Vulnerability Research API token",
          required: true,
          target: {
            kind: "secrets",
            field: "apiToken",
          },
          helperText:
            "Use the API Access Token shown under Settings > API > Tokens in Software Vulnerability Research. The documentation states that every user has a pre-generated token and that programmatic calls must use token authentication.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://api.app.secunia.com/api")
          .trim()
          .replace(/\/+$/, "") + "/advisories/?page_size=1",
      ...{ method: "GET", headers: { "Content-Type": "application/json" } },
    }),
  },
});
